<template>
  <Form
    class="formCls"
    :model="assignData"
    ref="ruleForm"
    label-position="right"
    label-width="100px"
  >
    <FormItem label="选择课件">
      <div class="flexBw">
        <Cascader
          ref="courseRef"
          style="width: 320px"
          :props="courseProps"
          placeholder="选择练习课件"
          @change="changeCourse"
        ></Cascader>
        <span
          class="preBtn flex-center"
          @click.stop="handleBtn"
          v-show="assignData.kind === 2 || assignData.courseId"
          >{{ assignData.kind === 2 ? "配置素材" : "预览课件" }}</span
        >
      </div>
      <div v-if="assignData.kind == 2 && assignData.title">
        素材已配置：素材名【{{ assignData.title }}】
      </div>
    </FormItem>
    <FormItem label="练习类型">
      <!-- <Input disabled value="课文朗读" style="width: 320px"></Input> -->
      <div class="flex selBox">
        <span
          :class="['item selI', assignData.type === i + 1 && 'sAct']"
          v-for="(item, i) in ['朗读', '背诵']"
          :key="'type' + i"
          @click.stop="assignData.type = i + 1"
          >{{ item }}</span
        >
      </div>
    </FormItem>
    <FormItem label="练习形式">
      <div class="flex selBox">
        <span
          :class="['item selI', assignData.readWay === i + 1 && 'sAct']"
          v-for="(item, i) in ['音频练习', '视频练习']"
          :key="'way' + i"
          @click.stop="assignData.readWay = i + 1"
        >
          {{ item }}
        </span>
        <span class="tips">请注意视频练习形式，当前不支持评分</span>
      </div>
    </FormItem>
    <FormItem
      label="练习范围"
      v-if="
        assignData.kind != 2 && (knowledgeList.length || sectionList.length)
      "
    >
      <div class="flex selBox">
        <template v-for="(item, i) in labList">
          <span
            :class="['item selI', artType === i && 'sAct']"
            v-show="
              !i ||
              (i == 1 && knowledgeList.length) ||
              (i == 2 && sectionList.length)
            "
            @click.stop="changeSel(i)"
          >
            {{ item
            }}<span
              class="labT"
              v-if="
                (i === 1 && assignData?.courseKnowledgeId) ||
                (i === 2 && assignData?.section)
              "
              >已选</span
            >
          </span>
        </template>
      </div>
    </FormItem>
    <FormItem label="选择班级">
      <Select
        v-model="assignData.classesIds"
        placeholder="请选择年级"
        style="width: 320px"
        :disabled="isDisabled"
      >
        <Option
          v-for="item in classList"
          :key="item.id"
          :label="
            item?.name?.includes('年级')
              ? item.name
              : item.gradeOutput + item.name
          "
          :value="item.id"
        ></Option>
      </Select>
    </FormItem>
    <FormItem label="提交时间">
      <DatePicker
        style="width: 320px"
        v-model="value"
        class="sumTime"
        popper-class="popperCls"
        prefix-icon=" "
        format="yyyy-MM-dd HH:mm"
        :editable="false"
        :clearable="false"
        type="datetime"
        placeholder="选择练习任务提交时间"
        :picker-options="pickerOptions"
        @change="dateChange"
      ></DatePicker>
    </FormItem>
    <FormItem label="练习说明">
      <Input
        v-model="assignData.remarks"
        type="textarea"
        maxlength="50"
        rows="4"
        style="width: 320px"
        show-word-limit
        placeholder="同学们，看看谁提交的练习又快又好"
      ></Input>
    </FormItem>
    <FormItem label="老师点评">
      <ElSwitch
        v-model="assignData.isRemark"
        :inactive-value="0"
        :active-value="1"
        active-color="#FB7C33"
      />
      <span class="commentTips">开启后，老师可以对练习进行文字或语音点评</span>
    </FormItem>
    <Button class="formBtn cancel" plain @click.stop="$emit('sureAssign')"
      >取消</Button
    >
    <Button
      :class="['formBtn summit', !isFinish && 'disable']"
      type="success"
      round
      @click="tapSure"
      >布置练习</Button
    >
    <div class="propBox" v-if="isShowKnow">
      <p class="mTitle">
        {{ artType === 2 ? "选择朗读段落" : "选择朗读知识点" }}
      </p>
      <div class="list">
        <div
          :class="[
            'item',
            (artType === 2
              ? assignData.section === item.section
              : assignData.courseKnowledgeId === item.id) && 'active',
          ]"
          v-for="(item, i) in artType === 1 ? knowledgeList : sectionList"
          :key="item.id"
          @click.stop="chooseKnowPoint(item)"
        >
          <p
            :class="[
              'selI label flexBw',
              (artType === 2
                ? assignData.section === item.section
                : assignData.courseKnowledgeId === item.id) && 'sAct',
            ]"
          >
            {{ item.kTitle }}
            <span
              class="preBtn flex-center"
              @click.stop="
                $emit('onPrev', item.textLabel, assignData.courseName)
              "
              >预览课件</span
            >
          </p>
          <p class="txt" v-html="item.text" style="white-space: pre-wrap"></p>
        </div>
      </div>
    </div>
    <CustomMaterial
      ref="customMaRef"
      @onCustomData="onCustomData"
    ></CustomMaterial>
  </Form>
</template>

<script>
import {
  DatePicker,
  Button,
  Form,
  FormItem,
  Cascader,
  Input,
  Select,
  Option,
  Switch,
} from "element-ui";
import { mapGetters } from "vuex";
import CustomMaterial from "./customMaterial";
export default {
  components: {
    DatePicker,
    Button,
    Form,
    FormItem,
    Cascader,
    Input,
    Select,
    Option,
    Button,
    ElSwitch: Switch,
    CustomMaterial,
  },
  data() {
    return {
      value: "",
      artType: null, // 段落类型
      assignData: {
        courseId: null,
        timeVal: "",
        classesIds: null,
        readWay: 1,
        type: 1, // 1：朗读，2：背诵
        isRemark: 1, // 是否开启点评
      },
      labList: Object.freeze(["整篇", "知识点", "段落"]),
      knowledgeList: [], // 知识点
      sectionList: [], // 段落
      classList: [],
      pickerOptions: {
        disabledDate(time) {
          return time.getTime() < Date.now() - 8.64e7;
        },
      },
      courseProps: { lazy: true, lazyLoad: this.lazyLoadFun },
      isShowKnow: false, // 知识点弹窗
      curAllTxt: "",
      isDisabled: false, // 班级是否可选
    };
  },
  computed: {
    isFinish() {
      let {
        classesIds,
        courseKnowledgeId,
        courseId,
        section,
        kind,
        readContents,
      } = this.assignData;
      if (kind === 2) return readContents && classesIds; // 自定义素材
      if (this.artType === 1)
        return classesIds && courseKnowledgeId && courseId;
      else if (this.artType === 2) return classesIds && section && courseId;
      return classesIds && courseId;
    },
  },
  watch: {
    "assignData.courseId"(val) {
      if (val) {
        this.isShowKnow = false;
        this.getKnowledge(val, "knowledgeList");
        this.getKnowledge(val, "sectionList");
      }
    },
  },
  methods: {
    onCustomData(data) {
      console.log("自定义素材", data);
      this.assignData = { ...this.assignData, ...data };
    },
    handleBtn() {
      let { kind, courseName } = this.assignData;
      if (kind === 2) return (this.$refs.customMaRef.status = true);
      this.$emit("onPrev", this.curAllTxt, this.assignData.courseName);
    },
    dateChange(val) {
      const date = new Date(val);
      const y = date.getFullYear();
      const m = date.getMonth() + 1;
      const d = date.getDate();
      const h = date.getHours();
      const min = date.getMinutes();
      let submitTime = `${y}${m < 10 ? `0${m}` : m}${d < 10 ? `0${d}` : d}${
        h < 10 ? `0${h}` : h
      }${min < 10 ? `0${min}` : min}`;
      this.assignData = { ...this.assignData, submitTime };
    },
    changeSel(i) {
      if (!+i && (this.sectionList.length || this.curAllTxt?.length > 800))
        return this.$toast("该素材内容较长，无法选择全篇布置～");
      if (this.artType !== i) {
        this.assignData = {
          ...this.assignData,
          courseKnowledgeId: "",
          section: "",
        };
      }
      this.artType = i;
      if (i) return (this.isShowKnow = true);
      this.isShowKnow = false;
      console.log(this.assignData);
    },

    chooseKnowPoint({ id, isOverall, kTitle, section }) {
      // if(+isOverall && this.artType === 1 && this.sectionList.length) return this.$toast('该素材内容较长，无法选择全篇布置～')
      this.assignData = {
        ...this.assignData,
        courseKnowledgeId: id,
        isOverall,
        kTitle,
        section: section || "",
      };
      this.isShowKnow = false;
    },

    close() {
      this.isShowKnow = false;
      this.resetData();
    },

    resetData() {
      this.assignData = { readWay: 1, type: 1, isRemark: 1 };
      this.isShowKnow = false;
      this.artType = null;
      this.value = "";
      this.knowledgeList = [];
      this.sectionList = [];
      // 清空选中值
      this.$refs.courseRef.checkedValue = "";
      // 清空级联选择器选中状态
      this.$refs.courseRef.$refs.panel.clearCheckedNodes();
      // 清除⾼亮
      this.$refs.courseRef.$refs.panel.activePath = [];
      // 初始化（只展示一级节点）
      this.$refs.courseRef.$refs.panel.syncActivePath();
    },

    // 课件筛选器
    changeCourse(val) {
      // console.log(this.$refs.courseRef.getCheckedNodes()[0].pathLabels);
      if (!val) return;
      // this.assignData.courseId = val[val.length - 1];
      let data = this.$refs.courseRef?.getCheckedNodes()[0]?.pathLabels || [];
      console.log("-------data--------", val);
      this.artType = null;
      if (val[val.length - 1] === "zidingyisucai") {
        this.assignData = {
          ...this.assignData,
          courseId: null,
          kind: 2,
        };
        return;
      }
      this.assignData = {
        ...this.assignData,
        kind: 1,
        courseId: val[val.length - 1],
        courseName: data[data.length - 1],
      };
      this.loadDetail();
    },

    async lazyLoadFun(node, resolve) {
      let nodes = [];
      const { level, value, parent } = node;
      console.log("----node====", node);
      if (!level) {
        nodes = [
          { value: "yuwenjiaocai", label: "语文教材" },
          { value: "songduziyuan", label: "诵读资源" },
          { value: "zidingyisucai", label: "自定义素材", leaf: 1 },
        ];
      }
      // 语文教材
      if (value === "yuwenjiaocai") {
        const bRes = await this.$post(
          "/recommend/home/teachingmaterial/list.json",
          {}
        );
        let result = bRes?.data?.objList || [];
        if (bRes.status == 200 && result.length) {
          nodes = Array.from(result).map((item) => ({
            value: item.id,
            label: item.name,
          }));
        }
      }
      if (value === "songduziyuan") {
        this.loadCategory(node, resolve);
      }
      if (parent) {
        if (parent.value === "yuwenjiaocai")
          this.loadBook(value, node, resolve);
        else {
          // 诵读资源
          let paths = parent.path || [];
          if (paths.includes("songduziyuan")) {
            if (level === 3)
              this.loadBookSearch(parent.value, value, node, resolve);
            else if (level === 4) this.loadBook(value, node, resolve);
          }
        }
      }
      resolve(nodes);
    },

    // 获取书本下的章节内容
    async loadBook(bookId, node, resolve) {
      const res = await this.$post("/book/info.json", { bookId });
      if (res.status == 200) {
        const courseKinds = res?.data?.courseKinds || [];
        const nodes = courseKinds.map((item) => {
          const child = {
            value: item.id,
            label: item.name,
            children: [],
          };
          child.children = item.courseList.map((cItem) => {
            return {
              value: cItem.id,
              label: cItem.name,
              leaf: 1,
            };
          });
          return child;
        });
        resolve(nodes);
      }
      // console.log("---语文教材---", res);
    },

    // 获取诵读资源下的分类、年级
    async loadCategory(node, resolve) {
      const res = await this.$post("/basic/data/book/category.json", {});
      const gRes = await this.$post("/basic/data/book/grade.json", {});
      let allObj = { id: "", name: "全部" };
      if (res.status == 200) {
        const nodes = [allObj, ...res?.data].map((item) => {
          const child = {
            value: item.id,
            label: item.name,
            children: [],
          };
          child.children = [allObj, ...gRes?.data].map((gItem) => {
            return {
              value: gItem.id,
              label: gItem.name,
            };
          });
          return child;
        });
        resolve(nodes);
      }
      // console.log("------分类----", res, gRes);
    },
    // 获取年级、二级分类下的书本
    async loadBookSearch(category = "", grade = "", node, resolve) {
      const params = {
        pageIndex: 1,
        pageSize: -1,
        grade,
        category,
      };
      const res = await this.$post("/book/search.json", params);
      if (res.status == 200) {
        const nodes = Array.from(res?.data?.list).map((item) => ({
          value: item.id,
          label: item.name,
        }));
        resolve(nodes);
      }
    },

    // 获取班级列表
    async getItemInfo() {
      const params = new URLSearchParams(window.location.search);
      let schoolId =  params.get('schoolId') || '';
      let classesId = +params.get('classesId') || 0;
      
      const gRes = await this.$get("/homework/classesList.json", { schoolId });
      this.classList = gRes.data || [];
       if (classesId) {
        this.assignData.classesIds = classesId;
        this.isDisabled = true;
       }
    },
    // 获取当前选择的课件的知识点
    async getKnowledge(courseId, key) {
      const isSection = key === "sectionList";
      const res = await this.$post(
        isSection ? "/course/sectionInfo.json" : "/course/knowledgeInfo.json",
        {
          courseId,
        }
      );
      let list = res.data || [];
      const hasAll = list[0]?.isOverall;
      for (let i = 0, len = list.length; i < len; i++) {
        list[i].kTitle =
          i || isSection
            ? `${isSection ? "段落" : "知识点"}${hasAll ? i : i + 1}`
            : "全篇知识点";
        // if (list[0]?.isOverall) {
        //   list[i].kTitle = i ? `${txt}${i}` : "全篇";
        // } else {
        //   list[i].kTitle = `${txt}${i + 1}`;
        // }
      }
      this[key] = list;
    },

    // 布置作业
    async tapSure() {
      if (!this.isFinish) return this.$toast("未完成相关选项填写");
      let data = this.assignData;
      if (data.kind === 1) {
        data = {
          ...data,
          title:
            data.courseKnowledgeId || data.section
              ? data.courseName + " " + data.kTitle
              : data.courseName,
          courseId: data.courseId,
        };
      }
      const res = await this.$post("/homework/save.json", data);
      if (res.data) {
        this.$toast("完成朗读练习布置");
        this.$emit("sureAssign", this.assignData.classesIds);
        this.$refs.customMaRef.resetData();
      } else this.$toast("朗读练习布置失败");
    },
    async loadDetail() {
      const res = await this.$post("/course/info.json", {
        courseId: this.assignData.courseId,
      });
      const { skills, article } = res.data || {};
      this.curAllTxt = this.filterStr(skills?.contents || article?.contents);
      // this.status = true;
    },
    filterStr(str = "") {
      return str
        .replace(/\[.*?\]/g, "") //去掉时间
        .replace(/\(([^)\s]*)\)/g, "") //使用正则表达式去掉拼音
        .replace(/([;$@])(.*?)=1/g, "") //去掉多余字符，如@isPara=1 \n
        .replace(/@textAlign=[a-zA-Z]+/g, "")
        .replace(/#zsd=\d/g, "") //去掉标识符#zsd=1和#zsd=2
        .trim();
    },
  },
  mounted() {
    this.getItemInfo();
  },
};
</script>

<style lang="less" scoped>
.selBox {
  flex-wrap: wrap;
  .item {
    margin-right: 50px;
  }
  .labT {
    color: #999999;
    font-size: 12px;
    position: absolute;
    right: -50%;
    top: 2px;
    font-size: 12px;
  }

  .tips {
    margin-top: -15px;
  }
}
.commentTips {
  margin-left: 15px;
  color: #999999;
  font-size: 12px;
}
.selI {
  padding-left: 20px;
  box-sizing: border-box;
  position: relative;
  color: #666666;
  cursor: pointer;

  &.sAct {
    color: #333333;

    &::before {
      border-color: #FB7C33;
    }

    &::after {
      content: "";
      width: 10px;
      height: 10px;
      background: #FB7C33;
      border-radius: 50%;
      position: absolute;
      left: 0px;
      top: 50%;
      transform: translateY(-50%);
    }
  }

  &::before {
    content: "";
    width: 16px;
    height: 16px;
    border-radius: 50%;
    border: 1px solid #dddddd;
    position: absolute;
    left: -4px;
    top: 50%;
    transform: translateY(-50%);
  }
}
.propBox {
  width: 60%;
  height: 100%;
  background: #ffffff;
  box-shadow: 0px 0 13px 1px rgba(189, 94, 39, 0.05),
    inset 0px 0 44px 13px rgba(255, 255, 255, 0.5);
  border-radius: 2px;
  display: flex;
  flex-direction: column;
  position: absolute;
  top: 50%;
  right: -61%;
  transform: translateY(-50%);

  .mTitle {
    text-align: center;
    font-size: 20px;
    color: #333333;
    padding-top: 20px;
  }

  .list {
    flex: auto;
    overflow-y: auto;
    padding: 0 20px 20px;
    box-sizing: border-box;
    margin-top: 20px;

    .item {
      width: 100%;
      padding: 8px 20px;
      box-sizing: border-box;
      color: #333333;
      font-size: 16px;
      line-height: 22px;
      cursor: pointer;

      .label {
        font-weight: bold;
        margin-bottom: 8px;
      }
      &.active {
        .label {
          color: #FB7C33;
        }
        background: rgba(251, 124, 51, 0.1);
      }
    }

    .gItem {
      width: 100%;
      padding: 20px 32px;
      box-sizing: border-box;
      color: #666666;
      font-size: 24px;
      justify-content: space-between;
      background: #efefef;
      margin-top: 16px;
      line-height: 33px;
      cursor: pointer;

      &.gItemAct {
        color: #FB7C33;
        background: rgba(251, 124, 51, 0.1);
      }

      .count {
        font-size: 16px;
      }
    }
  }
}

.preBtn {
  font-size: 16px;
  color: #ffffff;
  width: 80px;
  height: 32px;
  line-height: normal;
  border-radius: 5px;
  background: #FB7C33;
  cursor: pointer;
}
</style>

<style lang="less">
.formCls {
  width: 520px;
  margin: 0 auto;
}
.formBtn {
  cursor: pointer;
  &.cancel {
    width: 160px;
    height: 50px;
    border-radius: 25px;
  }
  &.summit {
    width: 260px;
    height: 50px;
    background: #FB7C33;
    border-radius: 25px;
  }

  &.disable {
    opacity: 0.5;
  }
}
.sumTime {
  .el-input__inner {
    cursor: pointer;
    padding-right: 14px;
  }
  &.el-input--prefix .el-input__inner {
    padding-left: 15px;
  }
}
.popperCls {
  .el-time-panel__btn.confirm,
  .el-date-table td.available:hover,
  .el-date-picker__header-label.active,
  .el-date-picker__header-label:hover,
  .el-year-table td .cell:hover,
  .el-year-table td.current:not(.disabled) .cell,
  .el-month-table td.today .cell,
  .el-month-table td .cell:hover,
  .el-picker-panel__icon-btn:hover,
  .el-year-table td.today .cell,
  .el-year-table td.today .cell:hover,
  .el-date-table td.today span,
  .Button--text,
  .Button--text:focus,
  .Button--text:hover {
    color: #FB7C33;
  }
  .el-input__inner:focus {
    border-color: #FB7C33;
  }
  .el-date-table td.current:not(.disabled) span {
    background-color: #FB7C33;
    color: #ffffff;
  }

  .el-time-spinner__item:hover:not(.disabled):not(.active) {
    background: rgba(251, 124, 51, 0.1);
  }
  .el-picker-panel__footer {
    button {
      color: #fff;
      background-color: #FB7C33;
      border-color: #FB7C33;
      &:first-child {
        display: none;
      }
    }
    .Button.is-plain:focus,
    .Button.is-plain:hover {
      opacity: 0.8;
      color: #fff;
      background-color: #FB7C33;
      border-color: #FB7C33;
    }
  }
}

.knowPop {
  min-height: 200px;
  max-height: 500px;
}
</style>
